import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Input, Row } from "antd";
import { _get, _post } from "../../Utils/Helper";
import { Col, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { acadamicTerms, academicYear, amount, code, school, year } from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import AcademicYearSelect from "../../../core/common/AcademicYearSelect";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

// Define the type for the student data
interface Student {
  id?: number;
  school_id: number,
  age?: number;
  section: string;
  student_name: string;
  email: string;
  phone: string;
  address: string;
  admission_no: string;
  state_of_origin: string;
  l_g_a: string;
  last_school_attended: string;
  current_class: string;
}

interface Payment {
  amount: number,
  term: string,
  academeic_year: string,
  admission_no: string;
  school_id: string;
  item_code: string;
  description: string;
  status: string;
  code: string;
  is_optional: string;
  student_type: string;
  discount: number,
  fines: number;
  checked: boolean;
}

// Define the props type for the component
interface StudentModalsProps {
  admission_no?: string; // Type of admission_no (you can change it if it's not a number)
  term?: string;
}

const StudentModals: React.FC<StudentModalsProps> = (props) => {
  const {user} = useSelector((s:RootState)=>s.auth)
  const { admission_no, term } = props;
  const StudentData = {
    id: 0,
    age: 0,
    section: '',
    student_name: '',
    email: '',
    phone: '',
    address: '',
    admission_no: '',
    current_class: "",
    state_of_origin: '',
    l_g_a: '',
    last_school_attended: '',
    school_id: user.school_id
  }
  const _form = {
    due_date:moment().format('YYYY-MM-DD'),
    query_type: "create",
    id: "",
    school_id: "",
    admission_no: "",
    item_code: "",
    description: "",
    amount: 0,
    qty: "1",
    academic_year: academicYear[0].value,
    term: term||acadamicTerms[0].value,
    discount: 0,
    class_name: "",
    created_by: "",
    fines: 0,
  }
  // Initialize the student state with the Student type
  const [student, setStudent] = useState<Student>(StudentData);
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState(_form)

  useEffect(() => {

    setLoading(true);
    _get(
      `students?query_type=select&admission_no=${admission_no}&term=${term}}`,
      (res: { data: Student[] }) => {
        if (res.data && res.data.length > 0) {
          setStudent(res.data[0]);
          setForm((p) => ({
            ...p,
            admission_no: res.data[0].admission_no,
            student_name: res.data[0].student_name,
            class_name: res.data[0].current_class
          }))
          setLoading(false);
          setForm((p)=>({...p, school_id:user.school_id}))
        }
      },
      (err: any) => {
        console.error(err);
        setLoading(false);
      }
    );
  }, [admission_no,term]);

  useEffect(() => {
    if (student?.current_class && admission_no) {
      setLoading(true);
      _post(
        `school/revenues`,
        {
          query_type: "select-revenues",
          class_name: student.current_class,
          term: form.term,
          school_id:student.school_id,
          admission_no
        },
        (resp) => {
          if (resp.success && resp.data.length) {
            setPayments(resp.data.map((x: Payment) => ({ ...x, checked: x?.is_optional === 'No' })));

            setSelectedRows(payments.filter((payment: Payment) => (payment?.is_optional === 'No')).map((x) => ({ ...x, checked: true })));
            setLoading(false);

          }
        },
        (err) => {
          console.error(err);
          setLoading(false);
        }
      );
    }
  }, [student?.current_class, student.school_id,admission_no]);

  const handleSubmit = () => {
    setLoading(true);
    const data = selectedRows.map(x => ({
      admission_no: form.admission_no,
      description: x.description,
      amount: x.amount,
      qty: 1,
      academic_year: form.academic_year,
      due_date: moment().format('YYYY-MM-DD'),
      created_by: user.name,
      item_code: x.code,
      discount:x.discount,
      fines:x.fines,
      term: form.term,
      class_name:student.current_class,
      query_type: 'create',
      school_id:student.school_id,
    }))
    // if(data.length>0){
    //   data.push({
    //     school_id:student.school_id,
    //     admission_no: form.admission_no,
    //     description: `Bill Summary: ${data[0].description}  ${data.length>2?`& (${data.length-2})`:data.length>=1?'& (1)':''} ${data.length>=1?"Other":""} ${data.length>=2?'Items':data.length>=1?"Item":""}`,
    //     amount: 0,
    //     qty: 1,
    //     class_name:student.current_class,
    //     academic_year: form.academic_year,
    //     due_date: form.due_date,
    //     created_by: user.name,
    //     discount: form.discount||0,
    //     fines: form.fines||0,
    //     item_code: data[0]?.item_code,
    //     term: form.term,
    //     query_type: 'create'
    //   })
    // }
    _post(
      `payments`,
      data,
      (resp) => {
        if (resp.success) {
          setLoading(false);
          setSelectedRows([])
          setPayments([])
          setForm(_form);
          // setPayments(resp.data.map((payment: Payment) => ({ 
          //   ...payment, 
          //   fines: 0, discount: 0, 
          //   checked: payment.is_optional === 'No' 
          // })));
          // setSelectedRows(resp.data.filter((payment: Payment) => (payment.is_optional === 'No')).map((x: Payment) => ({ ...x, checked: true, fines: 0, discount: 0,  })))
          // setLoading(false)
          toast.success("Submitted")
        }
      },
      (err) => {
        toast.error("Failed")
        console.error(err);
        setLoading(false);
      }
    );
  };

  const [selectedRows, setSelectedRows] = useState<Payment[]>(payments.filter((payment: Payment) => payment.checked));

  const total = selectedRows.reduce((acc:number, payment) => {
    return acc + Math.floor(payment.amount);
  }, 0);

  // const total_discount = selectedRows.reduce((acc, payment) => {
  //   return acc + parseFloat(payment.discount);
  // }, 0);

  // const total_fines = selectedRows.reduce((acc, payment) => {
  //   return acc + parseFloat(payment.fines);
  // }, 0);
  // Handle "Select All" checkbox
  const handleAddAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedRows(payments.map((payment: Payment) => ({ ...payment, checked: true })));
    } else {
      setSelectedRows(payments.filter((payment: Payment) => (payment.is_optional === 'No'))); // Clear all selections when "Select All" is unchecked
    }
  };

  // Handle individual row selection
  const handleAddList = (e: React.ChangeEvent<HTMLInputElement>, payment: Payment) => {
    if (e.target.checked) {
      setSelectedRows((prev) => {
        if (!prev.some((item) => item.code === payment.code)) {
          return [...prev, { ...payment, checked: true }];
        }
        return prev;
      });
    } else {
      setSelectedRows((prev) => prev.filter((item) => item.code !== payment.code));
    }
  };
  // Check if "Select All" checkbox should be checked
  const isAllSelected = payments.length > 0 && selectedRows.length === payments.length;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, payment: Payment) => {
    const { name, value } = e.target; // Get the input name and value
    setSelectedRows((prev) =>
      prev.map((item) =>
        item.code === payment.code
          ? { ...item, [name]: value }
          : item
      )
    );
  };
  const handleChangeForm=(e:React.ChangeEvent<HTMLInputElement>,)=>{
    const { name, value } = e.target;
    setForm((p)=>({...p, [name]:value}))
  }

  return (
    <div
      className="modal fade"
      id="add_fees_collect"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
            <h4 className="mb-3">{student?.student_name || ""} {student?.admission_no}</h4>
          </div>
          <div className="card">
            {/* {JSON.stringify(student)}x1 */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <div className="row">
                <div className="col-md-6">

                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <AcademicYearSelect
                      onChange={(year) => {
                        setForm((p) => ({ ...p, academic_year: year }))
                      }}
                      selectedYear={form.academic_year}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Term</label>
                    <CommonSelect
                      className="select"
                      options={acadamicTerms}
                      defaultValue={{
                        label: form.term,
                        value: form.term,
                      }}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          term: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Fees List */}
              <div className="custom-datatable-filter table-responsive">
                <table className="table datatable table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th>
                        <Input
                          name="admission_no"
                          checked={isAllSelected}
                          onChange={handleAddAll}
                          type="checkbox" />
                      </th>
                      <th>Description</th>
                      <th>Student Type</th>
                      <th>Amount (NGN)</th>
                    </tr>
                  </thead>
                  {payments.length && !loading ? <tbody>
                    {payments.map((payment: Payment, index: number) => (
                      <tr key={index}>
                        <td>
                          <Input
                            name="admission_no"
                            checked={selectedRows.some((item) => item.code === payment.code)}
                            onChange={(e) => handleAddList(e, payment)}
                            type="checkbox"
                          />
                        </td>
                        <td>
                          <p className="text-primary fees-group">
                            <span className="d-block">{payment.description}</span>
                          </p>
                        </td>
                        <td>
                          <span className="badge badge-soft-success d-inline-flex align-items-center">
                            <i className="ti ti-circle-filled fs-5 me-1" />
                            {payment.student_type}
                          </span>
                        </td>
                        <td>{payment.amount}</td>
                       
                        {/* <td><Input name="discount" onChange={(e) => handleChange(e, payment)} value={payment.discount} placeholder="Discount" type="number" /></td>
                        <td><Input name="fines" onChange={(e) => handleChange(e, payment)} value={payment.fines} type="number" /></td> */}
                      </tr>
                    ))}
                  </tbody> : loading ?
                    <Spinner /> :
                    <h3 className="text-warning text-center">N/A</h3>}
                </table>
              </div>
              {/* {JSON.stringify(selectedRows)} */}
              <Row>
                  <Col className="mx-8 px-8"  xs={6} md={6} sm={6} lg={6} xl={6} xxl={6}>
                     
                  <div className="form-group m-3">
                    <label>Total Invoice</label>

                    <Input 
                      placeholder="Total Invoice" 
                      value={total} 
                      type="text" 
                    />
                  </div>
                  <div className="form-group m-3">
                    <label>Discount</label>
                    <Input 
                      name="discount" 
                      onChange={handleChangeForm}  
                      value={form.discount} placeholder="Total Discount" 
                      type="number" 
                      />
                  </div>
                  </Col>
                  <Col className="mx-8 px-8" xs={6} md={6} sm={6} lg={6}>
                  <div className="form-group m-3">
                    <label>Total Payable</label>

                    <Input 
                      placeholder="Payable Invoice"
                      disabled={true} 
                      value={Math.floor(total) - Math.floor(form.discount)} 
                      type="text" 
                    />
                  </div>

                  <div className="form-group m-3">
                    <label>Due Date</label>
                    <Input name="due_date" onChange={handleChangeForm} placeholder="Due Date" value={form.due_date} type="date" />
                  </div>
                  </Col>
                  

              </Row>
              
            </div>
            <div className="card-footer">
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 5,
                }}
              >

                <Button
                  color="primary"
                  className="btn btn-primary p-2"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentModals;
